module.exports = __webpack_public_path__ + "img/36.14afe6b0.png";